import React from 'react';

import { zeosDialog } from '../components/Shared/confirm-dialog/ConfirmDialog';
import { PlacesAutocomplete } from '../components/Shared/PlacesAutocomplete';
import { ZeosInput } from '../components/Shared/ZeosInput';
import { ICompanyFormDataType } from '../services/forms/FormDataTypes';

interface IProps {
  formData: ICompanyFormDataType;
  errors: Record<string, string>;
  handleChange: (
    field: keyof ICompanyFormDataType
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<ICompanyFormDataType>>;
}

export const CompanyForm = (props: IProps) => {
  const { formData, errors, handleChange, setFormData } = props;
  const handleAddressSelect = (parsedAddress: any) => {
    const willOverwrite = [
      formData.address,
      formData.city,
      formData.state,
      formData.zip,
    ].some((val) => val && val.length > 0);

    const newAddress = {
      address:
        `${parsedAddress.StreetAddress} ${parsedAddress.StreetName}`.trim(),
      city: parsedAddress.City,
      state: parsedAddress.State,
      zip: parsedAddress.PostalCode,
    };

    if (willOverwrite) {
      zeosDialog("This will overwrite your current address fields. Continue?", [
        {
          label: "Continue",
          onClick: () => {
            setFormData((prev) => ({ ...prev, ...newAddress }));
          },
        },
        {
          label: "Cancel",
          onClick: () => {},
        },
      ]);
    } else {
      setFormData((prev) => ({ ...prev, ...newAddress }));
    }
  };

  return (
    <div className="grid grid-cols-12 gap-3">
      {/* Company Name and Website */}
      <div className="col-span-6 px-2">
        <ZeosInput
          name="companyName"
          label="Company Name"
          type="text"
          placeholder="Enter Company Name"
          value={formData.companyName}
          onChange={handleChange("companyName")}
          error={errors.companyName}
          required={true}
        />
      </div>

      <div className="col-span-6 px-2">
        <ZeosInput
          name="website"
          label="Company Website"
          type="text"
          value={formData.website}
          onChange={handleChange("website")}
          error={errors.website}
        />
      </div>

      {/* Address Lookup */}
      <div className="col-span-12 px-2 space-y-1">
        <p className="text-sm text-gray-600">
          Start typing your address or manually enter it below.
        </p>
        <PlacesAutocomplete
          label="Address Lookup"
          placeholder="Search by Address or Business Name"
          onSelect={handleAddressSelect}
        />
      </div>

      {/* Manual Address Fields */}
      <div className="col-span-6 px-2">
        <ZeosInput
          name="address"
          label="Address"
          type="text"
          value={formData.address}
          onChange={handleChange("address")}
          error={errors.address}
          required={true}
        />
      </div>

      <div className="col-span-6 px-2">
        <ZeosInput
          name="suite"
          label="Address (Suite / Room)"
          type="text"
          value={formData.suite}
          onChange={handleChange("suite")}
          error={errors.suite}
        />
      </div>

      <div className="col-span-6 px-2">
        <ZeosInput
          name="city"
          label="City"
          type="text"
          value={formData.city}
          onChange={handleChange("city")}
          error={errors.city}
          required={true}
        />
      </div>

      <div className="col-span-6 px-2">
        <ZeosInput
          name="state"
          label="State"
          type="text"
          value={formData.state}
          onChange={handleChange("state")}
          error={errors.state}
          required={true}
        />
      </div>

      <div className="col-span-3 px-2">
        <ZeosInput
          name="zip"
          label="Zipcode"
          type="text"
          value={formData.zip}
          onChange={handleChange("zip")}
          error={errors.zip}
          required={true}
        />
      </div>
    </div>
  );
};
